/**
 * Payloads for the JDE budget orchestrations (as rebuilt 8/5/2026):
 *
 *   STR_ORCH_Fusion_UploadBudget        stages one account: P0902Z1 STR0001
 *                                       writes the JA amount row, STR0006 the JU
 *                                       units row (EDI user FUSION). Every input
 *                                       is required.
 *   STR_ORCH_Fusion_ProcessBudgetUpload posts one job: R14110 STR0011 (final,
 *                                       replace entries) selects F0902Z1 rows
 *                                       for MCU = inORCH_BusUnit, then R51803
 *                                       STR0011 recalculates projections and
 *                                       emails both reports. Without the job it
 *                                       selects nothing.
 *
 * R14110 replaces the account's budget with each staged row, so two rows for
 * the same object/subsidiary leave only the last one: rows are summed per
 * account before they are sent.
 */

const UPLOAD_USER_ID = '154045';

const num = (v) => {
    const n = parseFloat(v || 0);
    return isNaN(n) ? 0 : n;
};

// Day Zero Budget rows -> one { costType, costCode, amt, units } per account.
// Revenue (4xxxx) goes to JDE as a negative amount.
export function aggregateBudgetRows(budgetData) {
    const byAccount = new Map();
    for (const row of budgetData || []) {
        const costType = row['Cost_Type'] || '';
        const costCode = row['Cost_Code'] || '';
        const key = `${costType}|${costCode}`;
        const amt = costType?.[0] === '4' ? -1 * num(row.Value_Amount) : num(row.Value_Amount);
        const units = costType ? num(row.Hours) : num(row.Quantity);
        const existing = byAccount.get(key);
        if (existing) {
            existing.amt += amt;
            existing.units += units;
        } else {
            byAccount.set(key, { costType, costCode, amt, units });
        }
    }
    return [...byAccount.values()];
}

// The period inputs are still required by UploadBudget, which ran
// ProcessBudgetUpload after every row until that step comes out in Studio.
export function uploadBudgetPayload(buId, row, period) {
    return {
        inORCH_BusUnit: String(buId),
        inORCH_Object: row.costType ? row.costType : '      ',
        inORCH_Sub: row.costCode ? row.costCode : '',
        inORCH_UserID: UPLOAD_USER_ID,
        inORCH_BudgetAmt: String(row.amt),
        inORCH_BudgetUnits: String(row.units),
        inORCH_Cent: period.century,
        inORCH_FY: period.fiscalYearShort,
        inORCH_BegPeriodNbr: period.periodNbr,
        inORCH_EndPeriodNbr: period.periodNbr,
        inORCH_BegFiscalYear: period.fiscalYear,
        inORCH_EndFiscalYear: period.fiscalYear
    };
}

// Projections are recalculated from period 01 of the fiscal year (858cecf).
export function processBudgetPayload(buId, period) {
    return {
        inORCH_Cent: period.century,
        inORCH_FY: period.fiscalYearShort,
        inORCH_BegPeriodNbr: '01',
        inORCH_EndPeriodNbr: period.periodNbr,
        inORCH_BegFiscalYear: period.fiscalYear,
        inORCH_EndFiscalYear: period.fiscalYear,
        inORCH_BusUnit: String(buId)
    };
}
